export default {
  admin: 10,
  global_manager: 8,
  local_manager: 6,
  pos_employee: 4,
  salesman: 2
};



// WEBPACK FOOTER //
// ./src/core/enum/role-weights.enum.js